import {
  SavedQueriesList,
  FilterLiveSearch,
  FilterList,
  FilterListItem,
  useTranslate,
  SearchInput,
} from 'react-admin';
import { Box, Card, CardContent } from '@mui/material';
import { AccountBalance, AttachMoney, History } from '@mui/icons-material';
import { addMonths, addWeeks, addYears } from 'date-fns';

const FilterByPaymentStatus = () => {
  const t = useTranslate();
  return (
    <FilterList label={t('paymentStatus')} icon={<AttachMoney />}>
      <FilterListItem label={t('paid')} value={{ paymentStatus: 'paid' }} />
      <FilterListItem label='unpaid' value={{ paymentStatus: 'pending' }} />
    </FilterList>
  );
};

const FilterByDate = () => {
  const t = useTranslate();
  return (
    <FilterList label={t('date')} icon={<History />}>
      <FilterListItem
        label={t('thisWeek')}
        value={{ createdAt: { gte: addWeeks(new Date(), -1) } }}
      />
      <FilterListItem
        label={t('thisMonth')}
        value={{
          createdAt: { gte: addMonths(new Date(), -1) },
        }}
      />

      <FilterListItem
        label={t('thisYear')}
        value={{
          createdAt: { gte: addYears(new Date(), -1) },
        }}
      />

      <FilterListItem
        label={t('allTime')}
        value={{
          createdAt: { gte: addYears(new Date(), -100) },
        }}
      />
    </FilterList>
  );
};

const FilterByPaymentMethod = () => {
  const t = useTranslate();
  return (
    <FilterList label={t('paymentMethod')} icon={<AccountBalance />}>
      <FilterListItem
        label={t('invoice')}
        value={{ paymentMethod: 'invoice' }}
      />
      <FilterListItem
        label={t('online')}
        value={{ paymentMethod: 'quickpay' }}
      />
    </FilterList>
  );
};

export const FilterOrder = () => {
  const t = useTranslate();

  return (
    <Box
      sx={{
        display: {
          xs: 'none',
          sm: 'block',
        },
        order: -1, // display on the left rather than on the right of the list
        width: '15em',
        marginRight: '1em',
        marginTop: '4rem',
      }}
    >
      <Card>
        <CardContent>
          <FilterByPaymentStatus />
          <FilterByDate />
          <FilterByPaymentMethod />
        </CardContent>
      </Card>
    </Box>
  );
};
